// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"5314770d67f4a69d","647":"da60431b0631cc4e","669":"5af86736783bbdf4","735":"4be63a2b82bd420c"}[chunkId] + ".js";
};